import { useEffect } from "react";

const WIDGET_ID = "01a0920fb0e870008cd6e7890a2ea66316e1";

export default function JotformReviews() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.jotform.com/website-widgets/embed/${WIDGET_ID}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return (
    <div
      id={`JFWebsiteWidget-${WIDGET_ID}`}
      data-testid="jotform-reviews-widget"
      className="min-h-[120px]"
    />
  );
}
